import * as sagaEffects from 'redux-saga/effects';
import { getFirestore } from 'redux-firestore';
import { getFirebase } from 'react-redux-firebase';
import { startSubmit, stopSubmit } from 'redux-form';

import { push } from 'connected-react-router';

import { getIntl } from '@ackee/jerome/antd';

import message from 'antd/lib/message';

import config from 'config/index';
import filterUndefined from 'utilities/filterUndefined';
import mergeEmpty from 'utilities/mergeEmpty';

import * as loglevel from 'config/loglevel';

import types from '../../actionTypes';
import { getOrder } from '../utilities';

const { takeEvery, put } = sagaEffects;

function* handler({ payload, meta }) {
    const firestore = getFirestore(getFirebase());
    const intl = yield getIntl();

    yield put(startSubmit(meta.form));

    try {
        let ref = yield firestore.collection(
            `languages/${config.app.defaultLanguage}/infoCategories/${meta.categoryId}/info`,
        );

        const order = yield getOrder(ref);
        const commonData = {
            order,
        };

        const defaultData = filterUndefined({
            ...payload[config.app.defaultLanguage],
            ...commonData,
        });

        const { id } = yield ref.add(defaultData);

        const languages = config.app.languages.filter(l => l !== config.app.defaultLanguage);
        for (const lang of languages) {
            const data = filterUndefined(mergeEmpty({}, defaultData, payload[lang]));
            ref = yield firestore.doc(`languages/${lang}/infoCategories/${meta.categoryId}/info/${id}`);
            yield ref.set(data);
        }

        yield put(stopSubmit(meta.form));
        yield put(push(config.routes.infoCategories));
        message.success(intl.formatMessage({ id: 'success.info.add' }));
    } catch (e) {
        yield put(stopSubmit(meta.form, { _error: 'errors.info.add' }));
        loglevel.error(e);
    }
}
export default function* () {
    yield takeEvery(types.ADD_INFO_REQUEST, handler);
}
